let custPayTypesCache = null;
let isInitialized = false;
let pendingPromise = null;
let cachedUserId = null;

let dictCache = {};
let dictPendingPromises = {};

export function initCustPayTypes(apiFn, userId) {
  return new Promise((resolve, reject) => {
    if (isInitialized && custPayTypesCache && cachedUserId === userId) {
      resolve(custPayTypesCache);
      return;
    }

    if (pendingPromise && cachedUserId === userId) {
      pendingPromise.then(resolve).catch(reject);
      return;
    }

    isInitialized = false;
    custPayTypesCache = null;
    pendingPromise = null;
    cachedUserId = userId;

    pendingPromise = apiFn({ custId: userId }).then((res) => {
      custPayTypesCache = res.data;
      isInitialized = true;
      pendingPromise = null;
      return res.data;
    }).catch((err) => {
      pendingPromise = null;
      cachedUserId = null;
      throw err;
    });

    pendingPromise.then(resolve).catch(reject);
  });
}

export function getCustPayTypesFromCache() {
  return custPayTypesCache;
}

export function getCustPayTypesAsync(apiFn, userId) {
  return new Promise((resolve, reject) => {
    if (isInitialized && custPayTypesCache && cachedUserId === userId) {
      resolve(custPayTypesCache);
      return;
    }

    initCustPayTypes(apiFn, userId).then(resolve).catch(reject);
  });
}

export function isCustPayTypesInitialized() {
  return isInitialized;
}

export function clearCustPayTypesCache() {
  custPayTypesCache = null;
  isInitialized = false;
  pendingPromise = null;
  cachedUserId = null;
}

export function updateCustPayTypesCache(data, userId) {
  custPayTypesCache = data;
  isInitialized = true;
  pendingPromise = null;
  if (userId) {
    cachedUserId = userId;
  }
}

export function getDictByTypeAsync(apiFn, type) {
  return new Promise((resolve, reject) => {
    if (dictCache[type]) {
      resolve(dictCache[type]);
      return;
    }

    if (dictPendingPromises[type]) {
      dictPendingPromises[type].then(resolve).catch(reject);
      return;
    }

    dictPendingPromises[type] = apiFn({ type: type }).then((res) => {
      dictCache[type] = res.data;
      dictPendingPromises[type] = null;
      return res.data;
    }).catch((err) => {
      dictPendingPromises[type] = null;
      throw err;
    });

    dictPendingPromises[type].then(resolve).catch(reject);
  });
}

export function getDictFromCache(type) {
  return dictCache[type];
}

export function clearDictCache(type) {
  if (type) {
    delete dictCache[type];
    delete dictPendingPromises[type];
  } else {
    dictCache = {};
    dictPendingPromises = {};
  }
}
